import { useState } from 'react';
import { LeftNavigationAccordion } from './LeftNavigationAccordion';
import '../styles/LeftNavigationAccordionGroup.scss';

export function LeftNavigationAccordionGroup({
    persistedFiltersGroup,
    items
}) {
    const [activeAccordion, setActiveAccordion] = useState(() => {
        const activeItem = items.find(item => item.selected || item.children.find(subItem => subItem.selected));
        return activeItem && activeItem.name;
    });

    return (
        <div className="left-navigation-accordion-group">
            {
                items.map(nav => (
                    <LeftNavigationAccordion
                        key={nav.navigationId || nav.name}
                        isOpen={activeAccordion === nav.name}
                        item={nav}
                        persistedFiltersGroup={persistedFiltersGroup}
                        onActiveAccordionChange={setActiveAccordion}
                    />
                ))
            }
        </div>
    );
}
